import React from 'react';
import { FieldError } from 'react-hook-form';

import { Container } from './styles';

interface TooltipProps {
  title: FieldError;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  className = '',
  children,
}) => {
  return (
    <Container className={className}>
      {children}
      <span>{title.message}</span>
    </Container>
  );
};

export default Tooltip;
